module.exports = __webpack_public_path__ + "img/DSC06875.8bbcd7e6.jpeg";